import { Component, OnInit, Inject, Input, EventEmitter, ElementRef, HostListener, Directive } from '@angular/core';
import { IFileStorageService } from 'src/app/core/services/api/contracts/file-storage.service';

@Directive({
    selector: '[fileDescriptorPreview]',
})
export class FileDescriptorPreviewDirective {
    _fileDescriptorId: string;

    get fileDescriptorId(): string {
        return this._fileDescriptorId;
    }

    @Input('fileDescriptorPreview')
    set fileDescriptorId(value: string) {
        this._fileDescriptorId = value;
        this.fileDescriptorIdChanged();
    }

    @HostListener('click') onMouseLeave() {
        this.prepareContentAndShowPreview();
    }

    private _fileDescriptorBase64: string;
    get fileDescriptorBase64(): string { return this._fileDescriptorBase64; }

    private _fileName: string;
    get fileName(): string { return this._fileName; }

    private _fileType: string;
    get fileType(): string { return this._fileType; }

    constructor(@Inject('IFileStorageService') private fileStorageService: IFileStorageService
    ) {
    }

    async fileDescriptorIdChanged() {
        let fileDescriptorBase64Model = await this.fileStorageService.getBase64(this.fileDescriptorId);
        this._fileName = fileDescriptorBase64Model.fileName;
        this._fileType = fileDescriptorBase64Model.fileType;
        this._fileDescriptorBase64 = fileDescriptorBase64Model.base64URL;
    }

    prepareContentAndShowPreview() {
        var blobFront = this.base64toBlob(this._fileDescriptorBase64, this._fileType);
        let fileContent = URL.createObjectURL(blobFront);
        window.open(fileContent, 'blank');
    }

    base64toBlob(base64Data: string, contentType: string) {
        let base64result = base64Data.split(',')[1];
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64result);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
}